import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { NavBar } from 'components/NavBar/NavBar'
import { Button } from 'components/ui/Button/Button'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { useState } from 'react'
import { Flex, H1WithBack, PageWrapper } from 'styling/GlobalStyles'
import { BodyText, OtherText } from 'styling/Typography'
import { ITaskRow } from 'types/operationsTasks.interface'

import { MOCK_TASKS } from './operationsTasksData'
import { EvenCell, EvenTableWrapper } from './OperationsTasks.styled'
import { AddTaskModal } from './AddTaskModal'

const columns: IHonestTableColumn<ITaskRow>[] = [
    {
        id: 'taskTemplate',
        header: 'Task template',
        sortable: true,
        sticky: true,
        cell: (item) => (
            <EvenCell>
                <BodyText weight='600'>{item.taskTemplate}</BodyText>
            </EvenCell>
        ),
    },
    {
        id: 'department',
        header: 'Department',
        sortable: true,
        cell: (item) => (
            <EvenCell>
                <BodyText>{item.department}</BodyText>
            </EvenCell>
        ),
    },
    {
        id: 'location',
        header: 'Location',
        sortable: true,
        cell: (item) => (
            <EvenCell>
                <BodyText>{item.location ?? '—'}</BodyText>
            </EvenCell>
        ),
    },
    {
        id: 'priority',
        header: 'Priority',
        sortable: true,
        cell: (item) => (
            <EvenCell>
                <StatusPill status={item.priority === 'Critical' ? 'danger' : 'accent'}>{item.priority}</StatusPill>
            </EvenCell>
        ),
    },
    {
        id: 'assignment',
        header: 'Assignment',
        sortable: true,
        cell: (item) => (
            <EvenCell>
                <BodyText>{item.assignment}</BodyText>
                {item.assignees && <OtherText grey>{item.assignees}</OtherText>}
            </EvenCell>
        ),
    },
    {
        id: 'startAt',
        header: 'Start at',
        sortable: true,
        cell: (item) => (
            <EvenCell>
                <BodyText>{item.startAt}</BodyText>
            </EvenCell>
        ),
    },
    {
        id: 'evidenceRequired',
        header: 'Evidence',
        cell: (item) => (
            <EvenCell>
                <BodyText>{item.evidenceRequired ? 'Required' : '—'}</BodyText>
            </EvenCell>
        ),
    },
]

export const OperationsTasks = () => {
    const [modalOpen, setModalOpen] = useState(false)

    return <>
        <NavBar />
        <PageWrapper>
            <Flex between width='100%' mb='16'>
                <H1WithBack arrow title='Tasks' />
                <Button variant='primary' onClick={() => setModalOpen(true)}>Add</Button>
            </Flex>
            <EvenTableWrapper>
                <HonestTable
                    columns={columns}
                    data={MOCK_TASKS}
                    keyField='id'
                />
            </EvenTableWrapper>
        </PageWrapper>
        {modalOpen && <AddTaskModal closeModal={() => setModalOpen(false)} />}
    </>
}
